import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import InfoIcon from '@mui/icons-material/Info'
import CloseIcon from '@mui/icons-material/Close'
import Slide from '@mui/material/Slide'
import SoftTypography from 'components/SoftTypography'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const NormalizedGrossDialog = () => {
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <React.Fragment>
      <IconButton onClick={handleClickOpen}>
        <InfoIcon />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Normalized Gross Income'}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <DialogContentText px={2} id="alert-dialog-description">
            <SoftTypography
              variant="p"
              textTransform="capitalize"
              fontWeight="bold"
            >
              Your Gross Income Less
            </SoftTypography>
            <br />
            <SoftTypography variant="p" textTransform="capitalize">
              • Social Security Taxes
              <br />• Medicare Taxes
              <br />• Pension Contributions
              <br />• TSP Contributions
            </SoftTypography>
            <br />
            <br />
            Finally Subtract: Survivor Benefit Election
            <br />
            <br />
            <SoftTypography
              variant="p"
              textTransform="capitalize"
              fontWeight="bold"
            >
              = Normalized Gross Income
            </SoftTypography>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}
